import PickingForDelivery from '@/models/PickingForDelivery/PickingForDelivery';

export default class PickingForDeliveryFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.pickingNumber = '';
		this.deliveryInstructionId  = '';
		this.deliveryInstructionDiNumber = '';
		this.pickingDateFrom = '';
		this.pickingDateTo = '';
		this.startDateFrom = '';
		this.startDateTo = '';
		this.finishDateFrom = '';
		this.finishDateTo = '';
		this.pickingByUserName  = '';
		this.pickingByFirstName = '';
		this.pickingStatusId  = '';
		this.pickingStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			pickingNumber : '0',
			deliveryInstructionId : '0',
			deliveryInstructionDiNumber : '0',
			pickingDateFrom : '0',
			pickingDateTo : '0',
			startDateFrom : '0',
			startDateTo : '0',
			finishDateFrom : '0',
			finishDateTo : '0',
			pickingByUserName : '0',
			pickingByFirstName : '0',
			pickingStatusId : '0',
			pickingStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}